import React from "react";
const createHighlightsHTML = ({
  searchWords = [],
  textToHighlight = "",
  highlightClassName,
}) => {
  searchWords = searchWords
    .filter((w) => !!w)
    .sort((a, b) => {
      return b.length - a.length;
    });
  // console.log({ searchWords, textToHighlight })
  const replacers = [];
  searchWords.forEach((word) => {
    if (word) {
      textToHighlight = textToHighlight.replace(
        new RegExp(`(${word})`, "ig"),
        (full, str) => {
          replacers.push(`<span class="${highlightClassName}">${str}</span>`);
          return `~${replacers.length}~`;
        }
      );
    }
  });
  while (replacers.length) {
    const str = `~${replacers.length}~`;
    const substitute = replacers.pop();
    textToHighlight = textToHighlight.replace(new RegExp(str, "g"), substitute);
  }
  return textToHighlight;
};
// eslint-disable-next-line react/prop-types
const Highlighter = ({ searchWords, textToHighlight, highlightClassName }) => (
  <span
    dangerouslySetInnerHTML={{
      __html: createHighlightsHTML({
        searchWords,
        textToHighlight,
        highlightClassName,
      }),
    }}
  />
);

export default Highlighter;
